'use client';

import { Switch, type SwitchProps } from '../../components/switch';
import { Text } from '../../components/text';
import { HStack } from '@terra/ui-styled-system';
import { automationId } from '@terra/shared-utils';
import type { ReactNode } from 'react';

export type SettingsBooleanControlProps = {
  checked: boolean;
  label?: ReactNode;
  disabled?: boolean;
  onCheckedChange?: SwitchProps['onCheckedChange'];
  testId?: string;
};

export function SettingsBooleanControl({
  checked,
  label,
  disabled,
  onCheckedChange,
  testId,
}: SettingsBooleanControlProps) {
  return (
    <HStack gap={2} alignItems="center">
      <Switch
        size="sm"
        checked={checked}
        disabled={disabled}
        onCheckedChange={onCheckedChange}
        {...(testId ? automationId(testId) : {})}
      />
      {label !== undefined && label !== null ? (
        typeof label === 'string' ? (
          <Text fontSize="sm" color="fg.neutral.default">
            {label}
          </Text>
        ) : (
          label
        )
      ) : null}
    </HStack>
  );
}
